import {tsInitVue} from './js-utils'

document.addEventListener('DOMContentLoaded', function () {
  const dataImportGridEl = document.querySelector('div[data-is="DataImportGrid"]')
  if (dataImportGridEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      const DataImportGrid = await import('../js/vue-components/data-import-grid.vue')
      window.dataImportGrid = tsInitVue(DataImportGrid.default, dataImportGridEl, {
        listUrl: dataImportGridEl.dataset.url,
      })
    })()
  }
})
